<template>
  <div class="d-flex justify-content-center align-items-center fill-width fill-height">
    <Flicking
      class="direction-ltr fill-width"
      ref="flicking"
      :options="{
        align: 'center',
        circular: false,
        bound: true,
      }"
      :plugins="plugins"
      @ready="onFlickingReady"
      @changed="onFlickingChange"
    >
      <b-container
        fluid
        class="mr-2 my-0 ml-0 p-0 d-flex justify-content-center align-items-center"
      >
        <SavedCardContainer
          :cardNumber="''"
          :doesUserHasSavedCards="userSavedCards.length > 0"
          @openAddToCardModal="openAddToCardModal"
        />
      </b-container>
      <!--                            <b-container-->
      <!--                              class="add-new-card-container direction-rtl pb-2"-->
      <!--                              fluid-->
      <!--                            >-->
      <!--                              <b-row>-->
      <!--                                <b-col-->
      <!--                                  cols="12"-->
      <!--                                  class="d-flex justify-content-end pt-2 pb-1"-->
      <!--                                >-->
      <!--                                  <b-row class="d-flex justify-content-end">-->
      <!--                                    <b-col-->
      <!--                                      cols="4"-->
      <!--                                      align-self="center"-->
      <!--                                      class="d-flex justify-content-center"-->
      <!--                                    >-->
      <!--                                      <b-img-->
      <!--                                        :src="-->
      <!--                                          require('@/assets/images/shetab-on.png')-->
      <!--                                        "-->
      <!--                                        class="p-1 border-radius-10px"-->
      <!--                                        fluid-->
      <!--                                      />-->
      <!--                                    </b-col>-->
      <!--                                  </b-row>-->
      <!--                                </b-col>-->
      <!--                                <b-col cols="12" class="mt-3">-->
      <!--                                  <b-row class="pb-3">-->
      <!--                                    <b-col-->
      <!--                                      cols="2"-->
      <!--                                      align-self="center"-->
      <!--                                      class="d-flex justify-content-center pr-2"-->
      <!--                                    >-->
      <!--                                      <button-->
      <!--                                        class="background-transparent border-none"-->
      <!--                                        @click="shetabAddToCardModalShow = true"-->
      <!--                                      >-->
      <!--                                        <b-icon-->
      <!--                                          icon="plus-circle"-->
      <!--                                          scale="2"-->
      <!--                                          class="text-white"-->
      <!--                                        ></b-icon>-->
      <!--                                      </button>-->
      <!--                                    </b-col>-->
      <!--                                    <b-col cols="10" align-self="center">-->
      <!--                                      <b-row>-->
      <!--                                        <b-col-->
      <!--                                          cols="12"-->
      <!--                                          align-self="start"-->
      <!--                                          class="d-flex justify-content-start pr-0"-->
      <!--                                        >-->
      <!--                                          <span-->
      <!--                                            class="font-weight-bold font-size-medium"-->
      <!--                                          >-->
      <!--                                            شماره کارت-->
      <!--                                          </span>-->
      <!--                                        </b-col>-->
      <!--                                        <b-col-->
      <!--                                          cols="12"-->
      <!--                                          align-self="center"-->
      <!--                                          class="d-flex justify-content-start pr-0"-->
      <!--                                        >-->
      <!--                                          <span-->
      <!--                                            class="new-subtext-color font-size-small font-weight-bold"-->
      <!--                                          >-->
      <!--                                            شماره کارت درج شده روی کارت را وارد-->
      <!--                                            کنید-->
      <!--                                          </span>-->
      <!--                                        </b-col>-->
      <!--                                      </b-row>-->
      <!--                                    </b-col>-->
      <!--                                    <b-col-->
      <!--                                      cols="12"-->
      <!--                                      class="mt-1"-->
      <!--                                      v-if="-->
      <!--                                        isCreditCardReceivedFromServer &&-->
      <!--                                        !getGatewayPendingFlag-->
      <!--                                      "-->
      <!--                                    >-->
      <!--                                      <b-row>-->
      <!--                                        <b-col-->
      <!--                                          class="px-1"-->
      <!--                                          cols="3"-->
      <!--                                          v-for="(key, i) in creditCardInfo"-->
      <!--                                          :key="i"-->
      <!--                                        >-->
      <!--                                          <input-->
      <!--                                            :value="creditCardInfo[i].value"-->
      <!--                                            :key="key"-->
      <!--                                            readonly-->
      <!--                                            class="new-form-control credit-card-input-background"-->
      <!--                                          />-->
      <!--                                        </b-col>-->
      <!--                                      </b-row>-->
      <!--                                    </b-col>-->
      <!--                                    <b-col-->
      <!--                                      cols="12"-->
      <!--                                      class="direction-ltr mt-1"-->
      <!--                                      v-if="!isCreditCardReceivedFromServer"-->
      <!--                                    >-->
      <!--                                      <b-row>-->
      <!--                                        <b-col-->
      <!--                                          class="px-1"-->
      <!--                                          cols="3"-->
      <!--                                          v-for="(key, i) in creditCardInfo"-->
      <!--                                          :key="i"-->
      <!--                                        >-->
      <!--                                          <input-->
      <!--                                            required-->
      <!--                                            @paste="onCreditCardInfoPaste"-->
      <!--                                            @input="handleAutoFocus(i)"-->
      <!--                                            :id="`credit-card-input-key${i}`"-->
      <!--                                            :key="i"-->
      <!--                                            v-model="key.value"-->
      <!--                                            pattern="\d*"-->
      <!--                                            inputmode="numeric"-->
      <!--                                            class="new-form-control credit-card-input-background"-->
      <!--                                            v-mask="'####'"-->
      <!--                                          />-->
      <!--                                        </b-col>-->
      <!--                                      </b-row>-->
      <!--                                    </b-col>-->
      <!--                                    <transition-->
      <!--                                      name="animate__fadeIn"-->
      <!--                                      :duration="200"-->
      <!--                                      enter-active-class="animate__animated animate__fadeIn "-->
      <!--                                      leave-active-class="animate__animated animate__fadeOut "-->
      <!--                                      appear-->
      <!--                                    >-->
      <!--                                      <b-col-->
      <!--                                        cols="12"-->
      <!--                                        class="d-flex justify-content-end align-items-center pt-1 direction-ltr"-->
      <!--                                        v-if="-->
      <!--                                          !secondContainerVisibility &&-->
      <!--                                          creditCardInfo[3].value.length === 4-->
      <!--                                        "-->
      <!--                                      >-->
      <!--                                        <span-->
      <!--                                          class="light-red-text font-size-xs font-weight-bold"-->
      <!--                                        >-->
      <!--                                          شماره کارت نا معتبر است-->
      <!--                                        </span>-->
      <!--                                      </b-col>-->
      <!--                                      <b-col-->
      <!--                                        cols="12"-->
      <!--                                        class="d-flex justify-content-end align-items-center pt-1"-->
      <!--                                        v-else-if="tempSaderatBankDisabled"-->
      <!--                                      >-->
      <!--                                        <span-->
      <!--                                          class="light-red-text font-size-xs font-weight-bold"-->
      <!--                                        >-->
      <!--                                          کارت های بانک صادرات موقتا پشتیبانی-->
      <!--                                          نمیشود-->
      <!--                                        </span>-->
      <!--                                      </b-col>-->
      <!--                                    </transition>-->
      <!--                                  </b-row>-->
      <!--                                </b-col>-->
      <!--                              </b-row>-->
      <!--                            </b-container>-->
      <b-container
        fluid
        class="d-flex justify-content-center align-items-center mr-0 my-0 ml-1 p-0"
        v-for="(card, index) in userSavedCards"
        :key="index"
      >
        <SavedCardContainer
          :key="index"
          :cardNumber="card.to"
          :cardInfo="card"
          :userCardVerificationReq="userCardVerificationReq"
          @openAddToCardModal="openAddToCardModal"
        />
      </b-container>
      <div
        slot="viewport"
        class="flicking-pagination py-1"
        v-show="userSavedCards.length > 0"
      ></div>
    </Flicking>
    <span
      class="flicking-arrow-prev is-outside"
      @click.prevent="moveFlicking('prev')"
      v-show="userSavedCards.length > 0"
    ></span>
    <span
      class="flicking-arrow-next is-outside"
      @click.prevent="moveFlicking('next')"
      v-show="userSavedCards.length > 0"
    ></span>
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn "
      leave-active-class="animate__animated animate__fadeOut "
      duration="300"
      appear
    >
      <button
        class="background-transparent border-none text-white d-flex justify-content-center align-items-center width-fit-content position-absolute close-button-position"
        v-if="selectedCardSlide > 0"
        @click="deleteCard()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="currentColor"
          class="bi bi-x-circle-fill"
          viewBox="0 0 16 16"
          style="color: #6b6b6b; background-color: white; border-radius: 50%"
        >
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"
          />
        </svg>
      </button>
    </transition>
    <!--    <b-button-->
    <!--        type="button"-->
    <!--        class="btn-success"-->
    <!--    >-->
    <!--      <svg-->
    <!--          xmlns="http://www.w3.org/2000/svg"-->
    <!--          width="16"-->
    <!--          height="16"-->
    <!--          fill="currentColor"-->
    <!--          class="bi bi-plus-circle-fill"-->
    <!--          viewBox="0 0 16 16"-->
    <!--      >-->
    <!--        <path-->
    <!--            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"-->
    <!--        ></path>-->
    <!--      </svg>-->
    <!--      اضافه کردن کارت-->
    <!--    </b-button>-->
  </div>
</template>

<script>
import alertHelper from "@/helper/AlertHelper";
import { Flicking } from "@egjs/vue-flicking";
import { Pagination } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.css";
import "@egjs/flicking-plugins/dist/arrow.css";
import SavedCardContainer from "@/components/Shetab/NewVersion/Helper/SavedCardContainer";
import { mapGetters } from "vuex";
export default {
  name: "FlickingSlider",
  components: { SavedCardContainer, Flicking },
  data() {
    return {
      selectedCardSlide: 0,
      plugins: [],
    };
  },
  props: {
    userSavedCards: Array,
    userCardVerificationReq: Boolean,
  },
  computed: {
    ...mapGetters(["getSavedSelectedCardSlide"]),
  },
  watch: {
    userSavedCards: {
      handler() {
        this.handleFlickingPlugins();
        this.refreshFlicking();
      },
      immediate: true, // runs immediately upon component creation
    },
  },

  methods: {
    handleFlickingPlugins() {
      if (this.userSavedCards?.length > 0)
        this.plugins = [new Pagination({ type: "fraction" })];
      else this.plugins = [];
    },
    getSelectedCardInfo() {
      //cardSlide number 0 is the add new card slide
      if (this.selectedCardSlide !== 0) {
        const i = this.selectedCardSlide - 1;
        if (i >= 0 && i < this.userSavedCards.length) {
          return this.userSavedCards[i];
        } else return "";
      } else return "";
    },
    // TODO: handle delete apis in the parent component
    deleteCard() {
      if (!this.getSelectedCardInfo().to) return;
      const alertWarnText =
        "آیا از حذف شماره کارت " +
        this.getSelectedCardInfo().to +
        " از لیست کارت های خود اطمینان دارید؟";
      alertHelper
        .warningAlert("حذف کارت", alertWarnText, "بله", "انصراف")
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteCardRequest(this.getSelectedCardInfo());
          }
        });
    },
    deleteCardRequest(cardInfo) {
      const paymentId = this.$route.query.id;
      alertHelper.loadingAlert();
      this.$http.delete(`payments/${paymentId}/cards/${cardInfo.id}`).then(
        (result) => {
          if (result.body.status === "Success") {
            this.$emit("getSavedCards");
            alertHelper.successAlert("", "کارت با موفقیت حذف شد");
          }
        },
        (error) => {
          alertHelper.apiErrorAlert("", error.body.message);
        }
      );
    },
    openAddToCardModal() {
      this.$emit("openAddToCardModal");
    },
    refreshFlicking() {
      const flicking = this.$refs.flicking;
      if (flicking && typeof flicking.refresh === "function") {
        flicking.refresh();
      }
    },

    // flickingPaginationUpdate() {
    // const renderer = this.plugins[0]._renderer;
    // Now you can use the render method separauserCardVerificationReqtely
    // renderer.render();
    // console.log(this.plugins[0].update);
    // },
    emitSelectedCardSlide() {
      this.$emit("getSelectedCardSlide", this.selectedCardSlide);
    },

    // //checking the selected card for when the user comes back to
    // //the first page.
    // checkTheSelectedCardSlide() {
    //   if (this.getSavedSelectedCardSlide !== 0) {
    //     this.selectedCardSlide = this.getSavedSelectedCardSlide;
    //     this.moveFlicking(5);
    //   }
    // },
    onFlickingReady(event) {
      this.selectedCardSlide = event.currentTarget.index;
      this.emitSelectedCardSlide();
    },
    onFlickingChange(event) {
      this.selectedCardSlide = event.index;
      this.emitSelectedCardSlide();
    },
    moveFlicking(direction) {
      const flicking = this.$refs.flicking;
      const flickingLastIndex = flicking.$children.length - 1;
      if (flicking) {
        if (direction === "prev" && flicking.index !== 0) {
          flicking.prev();
        } else if (direction === "next" && flicking.index !== flickingLastIndex) {
          flicking.next();
        } else if (direction === "first") {
          flicking.moveTo(1);
        } else if (
          flicking.index !== 0 &&
          +direction !== 0 &&
          +direction < flickingLastIndex &&
          +direction > 0
        ) {
          //if the direction was a specific index
          flicking.moveTo(+direction);
        }
      }
      this.refreshFlicking();
    },
  },
  // mounted() {
  // this.handleFlickingPlugins();
  // },
};
</script>

<style scoped>
.close-button-position {
  left: -6%;
  top: -5%;
  z-index: 2;
}
</style>
